import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './store/auth';
import { Shell } from './components/Shell';
import { LoginPage } from './pages/Login';
import { HomePage } from './pages/Home';
import { SettingsPage } from './pages/Settings';
import { ListScreen } from './pages/ListScreen';
import { FormScreen } from './pages/FormScreen';
import { PaymentNew } from './pages/PaymentNew';
import { BudgetReport } from './pages/BudgetReport';
import { ConsolidationPage } from './pages/ConsolidationPage';
import { AdminPage } from './pages/admin/AdminPage';
import { DesignerPage } from './pages/admin/designer/DesignerPage';

export function App() {
  const token = useAuth(s => s.token);
  // Content density: cozy (bigger tap targets) on phones, compact (denser) on desktop — the Fiori norm.
  useEffect(() => {
    const apply = () => {
      const mobile = window.innerWidth < 700;
      document.body.classList.toggle('sapUiSizeCozy', mobile);
      document.body.classList.toggle('sapUiSizeCompact', !mobile);
    };
    apply();
    window.addEventListener('resize', apply);
    return () => window.removeEventListener('resize', apply);
  }, []);
  if (!token) return <Routes><Route path="*" element={<LoginPage />} /></Routes>;
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* Generic, metadata-driven screens defined by the administrator (stored in SAP @B1L_SCREEN) */}
        <Route path="/s/:screenId" element={<ListScreen />} />
        <Route path="/s/:screenId/new" element={<FormScreen />} />
        <Route path="/s/:screenId/:key" element={<FormScreen />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/:tab" element={<AdminPage />} />
        <Route path="/admin/designer" element={<DesignerPage />} />
        <Route path="/admin/designer/:screenId" element={<DesignerPage />} />
        <Route path="/payments/new" element={<PaymentNew />} />
        <Route path="/budget/report" element={<BudgetReport />} />
        <Route path="/consolidation" element={<ConsolidationPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}
